import { createContext, useContext } from 'solid-js';
import type { JSX } from 'solid-js';

/* Holds the list of {category,type} refs currently active from ancestor contexts.
   Provided at the page level by SectionList and updated at each nested Styles component. */

export interface ActiveStyleRef { category: string; type: string; }

const ActiveStylesContext = createContext<() => ActiveStyleRef[]>(() => []);

export function ActiveStylesProvider(P: { activeStyles: () => ActiveStyleRef[], children: JSX.Element })
{
	return (
		<ActiveStylesContext.Provider value={P.activeStyles}>
			{P.children}
		</ActiveStylesContext.Provider>
	);
}

export function useActiveStyles(): () => ActiveStyleRef[]
{
	return useContext(ActiveStylesContext);
}
